export const TABLE_COLUMN_PREFERENCES_STORAGE_PREFIX = 'certiplate.table.columnPreferences';

export function buildTableColumnPreferencesKey(params: {
  userId: string | number | null | undefined;
  orgId: string | number | null | undefined;
  moduleType?: string | null;
  pageType?: string | null;
}): string {
  const userPart = params.userId ?? 'anonymous';
  const orgPart = params.orgId ?? 'unknown-org';
  const modulePart = (params.moduleType || 'default').toLowerCase().replace(/\s+/g, '-');
  const pagePart = (params.pageType || 'default').toLowerCase().replace(/\s+/g, '-');

  return [
    TABLE_COLUMN_PREFERENCES_STORAGE_PREFIX,
    userPart,
    orgPart,
    modulePart,
    pagePart
  ].join(':');
}
